import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
const {FiPhone,FiAlertTriangle,FiShield,FiUsers,FiHeart}=FiIcons;
const EmergencyNumbers=()=> {
const emergencyServices=[
{name: 'National Emergency',number: '911',icon: FiPhone,description: 'General emergency hotline',color: 'text-red-600',bgColor: 'bg-red-50'},
{name: 'NDRRMC',number: '(02) 911-1406',icon: FiShield,description: 'National Disaster Risk Reduction',color: 'text-blue-600',bgColor: 'bg-blue-50'},
{name: 'PNP',number: '117',icon: FiUsers,description: 'Philippine National Police',color: 'text-green-600',bgColor: 'bg-green-50'},
{name: 'Bureau of Fire',number: '(02) 426-0219',icon: FiAlertTriangle,description: 'Fire Department',color: 'text-orange-600',bgColor: 'bg-orange-50'},
{name: 'Red Cross',number: '143',icon: FiHeart,description: 'Philippine Red Cross',color: 'text-red-500',bgColor: 'bg-red-50'},
];
const regionalHotlines=[
{region: 'Luzon',numbers: ['(02) 8921-9200','(02) 8921-9201']},
{region: 'Visayas',numbers: ['(032) 412-6366','(032) 412-6367']},
{region: 'Mindanao',numbers: ['(082) 227-8034','(082) 227-8035']},
];
return (
<motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} className="bg-white rounded-lg shadow-md p-6 border-t-4 border-red-500" >
<div className="flex items-center space-x-2 mb-4">
<SafeIcon icon={FiAlertTriangle} className="text-red-600 text-xl" />
<h3 className="text-lg font-semibold text-gray-900">Emergency Hotlines</h3>
</div>
<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
{emergencyServices.map((service,index)=> (
<motion.div key={service.name} initial={{opacity: 0,y: 10}} animate={{opacity: 1,y: 0}} transition={{delay: index * 0.1}} className={`${service.bgColor} rounded-lg p-4 border border-gray-200`} >
<div className="flex items-center space-x-3">
<SafeIcon icon={service.icon} className={`${service.color} text-xl`} />
<div>
<div className="font-semibold text-gray-900">{service.name}</div>
<div className={`text-2xl font-bold ${service.color}`}>{service.number}</div>
<div className="text-xs text-gray-600 mt-1">{service.description}</div>
</div>
</div>
</motion.div>
))}
</div>
<div className="border-t border-gray-200 pt-4">
<h4 className="font-medium text-gray-900 mb-3">Regional NDRRMC Hotlines</h4>
<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
{regionalHotlines.map((region)=> (
<div key={region.region} className="bg-gray-50 rounded-lg p-3">
<div className="font-medium text-gray-900 mb-2">{region.region}</div>
{region.numbers.map((number,idx)=> (
<div key={idx} className="text-sm text-gray-600 font-mono">{number}</div>
))}
</div>
))}
</div>
</div>
<div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
<div className="flex items-start space-x-2">
<SafeIcon icon={FiAlertTriangle} className="text-amber-600 text-sm mt-0.5 flex-shrink-0" />
<div className="text-xs text-amber-800">
<strong>Important:</strong> Call these numbers only during real emergencies. For non-emergency inquiries, contact your local government units or the appropriate agencies during business hours.
</div>
</div>
</div>
</motion.div>
);
};
export default EmergencyNumbers;